import { createSelector } from '@reduxjs/toolkit';

import { formBlockFFSelector, getCreditPurposeFormViewOptions, selectCreditPurposeInfoData } from 'entities/creditForm';
import { selectIsSelectedProductTypeFeatureEnabled } from 'entities/siteSettings';

export const selectCreditPurposeFormViewOptions = createSelector(
  [formBlockFFSelector, selectCreditPurposeInfoData, selectIsSelectedProductTypeFeatureEnabled],
  (blockFF, creditPurposeData, isShowProductTypeSelection) =>
    getCreditPurposeFormViewOptions({
      selectedProductType: creditPurposeData.selectedProductType,
      withoutAdditionalFilters: blockFF?.withoutAdditionalFilters,
      isCreditCardsForm: blockFF?.isCreditCardsForm,
      isShowProductTypeSelection,
    }),
);
